import { render, staticRenderFns } from "./PackMenuList.vue?vue&type=template&id=d5fb667a&scoped=true&"
import script from "./PackMenuList.vue?vue&type=script&lang=js&"
export * from "./PackMenuList.vue?vue&type=script&lang=js&"
import style0 from "./PackMenuList.vue?vue&type=style&index=0&id=d5fb667a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fb667a",
  null
  
)

export default component.exports